import { everyTrue } from 'aa_common/front-end/helpers'
import { PresenterDepreciationMonthlyResponse } from 'common/open-api'

import { AcceleratedDepreciationItem } from '../types'

export const setBeginningBookValueForAccelerated = (
  monthlyDepreciation: AcceleratedDepreciationItem[],
  originalMonthlyDepreciation: PresenterDepreciationMonthlyResponse[]
) => {
  const indexFirstAdjustableItem = originalMonthlyDepreciation.findIndex(item => item.is_adjustable)
  const depreciationOfFirstAdjustableItem = monthlyDepreciation.find(item =>
    everyTrue(
      item.year === originalMonthlyDepreciation[indexFirstAdjustableItem]?.year,
      item.month === originalMonthlyDepreciation[indexFirstAdjustableItem]?.month
    )
  )

  return originalMonthlyDepreciation.map((item, index) => {
    let beginningBookValue = item.beginning_book_value
    if (index === indexFirstAdjustableItem && depreciationOfFirstAdjustableItem) {
      beginningBookValue = depreciationOfFirstAdjustableItem.beginning_book_value
    }
    return { ...item, beginning_book_value: beginningBookValue }
  })
}
